var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"cs-link",class:{ 'has-button': _vm.hasButton },attrs:{"href":_vm.href,"target":_vm.target},on:{"click":function($event){return _vm.clickHandler($event)}}},[_vm._t("default",[_vm._v(_vm._s(_vm.title))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }